import { render, staticRenderFns } from "./MacroAnalysisDetaiInfoTabel.vue?vue&type=template&id=c3e36d94&scoped=true"
import script from "./MacroAnalysisDetaiInfoTabel.vue?vue&type=script&lang=js"
export * from "./MacroAnalysisDetaiInfoTabel.vue?vue&type=script&lang=js"
import style0 from "./MacroAnalysisDetaiInfoTabel.vue?vue&type=style&index=0&id=c3e36d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e36d94",
  null
  
)

export default component.exports